import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import editorStyle from '../util/defaultStyle';
import Item from '@antv/g6/lib/item/item';
import { deepMix } from '@antv/util';
var Anchor = /*#__PURE__*/function (_Item) {
  _inherits(Anchor, _Item);
  var _super = _createSuper(Anchor);
  function Anchor(cfg) {
    var _this;
    _classCallCheck(this, Anchor);
    _this = _super.call(this, deepMix(cfg, {
      type: 'anchor',
      isActived: false,
      model: {
        type: 'anchor',
        style: _objectSpread(_objectSpread({}, editorStyle.anchorPointStyle), {}, {
          cursor: editorStyle.cursor.hoverEffectiveAnchor
        })
      }
    }));
    _this.enableCapture(true);
    _this.isAnchor = true;
    _this.toFront();
    return _this;
  }
  _createClass(Anchor, [{
    key: "showHotpot",
    value: function showHotpot() {
      this.hotpot = this.getContainer().addShape('marker', {
        attrs: _objectSpread(_objectSpread({}, this.get('model').style), editorStyle.anchorHotsoptStyle),
        name: 'hotpot-shape',
        draggable: true
      });
      this.hotpot.toFront();
      this.getKeyShape().toFront();
    }
  }, {
    key: "setActived",
    value: function setActived() {
      this.update({
        style: _objectSpread({}, editorStyle.anchorPointHoverStyle)
      });
    }
  }, {
    key: "clearActived",
    value: function clearActived() {
      this.update({
        style: _objectSpread({}, editorStyle.anchorPointStyle)
      });
    }
  }, {
    key: "setHotspotActived",
    value: function setHotspotActived(act) {
      this.hotpot && (act ? this.hotpot.attr(editorStyle.anchorHotsoptActivedStyle) : this.hotpot.attr(editorStyle.anchorHotsoptStyle));
    }
  }]);
  return Anchor;
}(Item);
export { Anchor as default };